module.exports = __webpack_public_path__ + "static/img/meiguihua.0b495888.png";